import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Breadcrumb } from '../../../../vtex-apps/breadcrumb/Breadcrumb/default';

export default function BreadcrumbGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'BreadcrumbGroup',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({
			blockClass: 'flex-row__breadcrumb-1',
			colSizing: 'auto',
			mzTitle: 'MZ | Breadcrumb',
		}).props,
		childrenComponents: [Breadcrumb({ blockClass: 'breadcrumb-1', homeIconSize: 20 })],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--breadcrumb-1-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--breadcrumb-1-active-color', name: 'Text Active' },
			{ from: '--text-color-1', to: '--breadcrumb-1-home-color', name: 'Home Icon' },
			{ from: '--text-color-1', to: '--breadcrumb-1-arrow-color', name: 'Arrow Icon' },
		],
	},
	{ type: 'fontSize', list: [{ from: '--font-size-xs', to: '--breadcrumb-1-fs', name: 'Text' }] },
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--breadcrumb-1-text-fw', name: 'Text' },
			{ from: '--font-weight-700', to: '--breadcrumb-1-active-fw', name: 'Text Active' },
		],
	},
	{ type: 'typography', list: [{ from: '--main-font', to: '--breadcrumb-1-text-ff', name: 'Text' }] },
];
